import { Component, HostBinding } from '@angular/core';
import { ContentModule } from '@tytapp/content';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { ButtonBlock } from './button-block';


@Component({
    selector: 'tyt-button-block',
    standalone: true,
    imports: [
        ContentModule
    ],
    template: `
        @for (button of block.buttons; track button) {
          <a
            mat-button
            [class.mat-raised-button]="button.style !== 'discrete'"
            [color]="
                button.style === 'primary'
                    ? 'primary' :
                button.style === 'secondary'
                    ? 'secondary' :
                undefined
            "
            [url]="button.url"
            [attr.data-style]="button.style"
            [class.stretch]="button.stretch"
            >
            @if (button.icon && button.icon.type !== 'none') {
              <tyt-icon [size]="24" [icon]="button.icon"></tyt-icon>
            }
            {{ button.text ?? 'Button' }}
          </a>
        }
        `,
    styles: [`
        @use 'styles/colors' as colors;

        :host {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 1em;
            margin: 1em 0;
        }
        :host[data-alignment="center"] { justify-content: center; }
        :host[data-alignment="right"] { justify-content: right; }

        a {
            $c2a-padding: 0.25em 2em;

            &.stretch {
                flex-grow: 1;
            }

            &[data-style="membership"] {
                color: black;
                background-color: colors.$tyt-plus;
                border-radius: 0;
                padding: $c2a-padding;
            }
            &[data-style="donation"] {
                color: white;
                background-color: colors.$tyt-donation;
                border-radius: 0;
                padding: $c2a-padding;
            }
            &[data-style="community"] {
                color: black;
                background-color: colors.$tyt-community;
                border-radius: 0;
                padding: $c2a-padding;
            }
            &[data-style="wasabi"] {
                color: black;
                background-color: #BCCC6D;
            }
            &[data-style="strawberry"] {
                color: black;
                background-color: #C73F4A;
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<ButtonBlock> {
    @HostBinding('attr.data-alignment') get alignment() { return this.block.alignment; }
}
